import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import { css } from '@emotion/css';
import { theme, setDefault } from '../../styles/theme';
import { deepDefaults } from '../../styles/utils';
import '../../styles/global';
import { cache } from '../utils';
var defaults = {
  padding: '8px 12px',
  get color() {
    return theme.color.text;
  },
  bgColor: '#fff',
  lineHeight: 1.4,
  maxWidth: '312px',
  get boxShadow() {
    return theme.middleBoxShadow;
  },
  // arrow
  arrow: {
    borderColor: 'rgba(221, 221, 221, .5)',
    width: '6px'
  },
  // confirm
  confirm: {
    gaps: '8px'
  },
  // dark
  dark: {
    get bgColor() {
      return theme.color.title;
    },
    color: '#fff',
    get arrowBorderColor() {
      return theme.color.title;
    }
  },
  smallPadding: '4px'
};
export var tooltip;
setDefault(function () {
  tooltip = deepDefaults(theme, {
    tooltip: defaults
  }).tooltip;
  makeStyles == null || makeStyles.clearCache();
});
export var themes = ['dark', 'light'];
var directionMap = {
  top: 'bottom',
  bottom: 'top',
  left: 'right',
  right: 'left'
};
export var makeStyles = cache(function makeStyles(k) {
  var arrowLong = tooltip.arrow.width;
  var arrowShort = "calc(" + arrowLong + " - 1px)";
  // use &.${k}-tooltip-content to override css in dropdown menu
  return /*#__PURE__*/css("&.", k, "-tooltip-content{max-width:", tooltip.maxWidth, ";min-width:0;padding:", tooltip.padding, ";line-height:", tooltip.lineHeight, ";word-wrap:break-word;pointer-events:none;box-shadow:", tooltip.boxShadow, ";&.", k, "-hoverable,&.", k, "-always{pointer-events:all;}.", k, "-tooltip-arrow{pointer-events:none;&:before,&{position:absolute;display:block;border-style:solid;border-color:transparent;}&:before{content:' ';}&.", k, "-top,&.", k, "-bottom{&:before,&{border-width:", arrowLong, " ", arrowShort, ";}&:before{left:calc(-1 * ", arrowShort, ");}}&.", k, "-top{top:calc(-2 * ", arrowLong, ");&:before{top:calc(-", arrowLong, " + 1px);}}&.", k, "-bottom{bottom:calc(-2 * ", arrowLong, ");&:before{bottom:calc(-", arrowLong, " + 1px);}}&.", k, "-left,&.", k, "-right{&:before,&{border-width:", arrowShort, " ", arrowLong, ";}&:before{top:calc(-1 * ", arrowShort, ");}}&.", k, "-left{left:calc(-2 * ", arrowLong, ");&:before{left:calc(-", arrowLong, " + 1px);}}&.", k, "-right{right:calc(-2 * ", arrowLong, ");&:before{right:calc(-", arrowLong, " + 1px);}}}", _mapInstanceProperty(themes).call(themes, function (theme) {
    var _context;
    var borderColor;
    var bgColor;
    var color;
    if (theme === 'dark') {
      borderColor = tooltip.dark.arrowBorderColor;
      bgColor = tooltip.dark.bgColor;
      color = tooltip.dark.color;
    } else {
      borderColor = tooltip.arrow.borderColor;
      bgColor = tooltip.bgColor;
      color = tooltip.color;
    }
    return /*#__PURE__*/css("&.", k, "-", theme, "{background:", bgColor, ";color:", color, ";.", k, "-tooltip-arrow{", _mapInstanceProperty(_context = _Object$keys(directionMap)).call(_context, function (direction) {
      var borderDirection = directionMap[direction];
      return /*#__PURE__*/css("&.", k, "-", direction, "{border-", borderDirection, "-color:", borderColor, ";&:before{border-", borderDirection, "-color:", bgColor, ";}}");
    }), ";}}");
  }), ".", k, "-tooltip-footer{padding-top:", tooltip.confirm.gaps, ";.", k, "-btn:not(:first-of-type){margin-left:", tooltip.confirm.gaps, ";}}&.", k, "-small{padding:", tooltip.smallPadding, ";}}");
});